import ContactAddressInformation from './ContactAddressInformation.component';

export default ContactAddressInformation;
